import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import Navbar from "../../component/Navbar";
import { baseurl } from "../../component/Baseurl";

function VisitorHotelBookingFinalPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const formData = location.state || {};
  const [razorpayLoaded, setRazorpayLoaded] = useState(false);
  
// ✅ Define queryParams first
const queryParams = new URLSearchParams(location.search);


  // State to store updated price calculations
// State to store updated price calculations
const [updatedData, setUpdatedData] = useState({
    mrp: 0,
    price: 0,
    tax: formData.tax || 0,
    admin_markup: formData.admin_markup || 0,
    travelers: formData.travelers || [],
    ResultToken: formData.ResultToken || "", // ✅ Extract from formData
    RoomUniqueId: formData.RoomUniqueId || "", // ✅ Extract from formData
    agentid: formData.agentid || "", // ✅ Extract from formData
  });
  

  // Calculate new MRP & Price including admin markup
  useEffect(() => {
    const newMrp = (parseFloat(formData.mrp) || 0) + (parseFloat(formData.admin_markup) || 0);
    const newPrice = (parseFloat(formData.price) || 0) + (parseFloat(formData.admin_markup) || 0);
    
    setUpdatedData((prev) => ({
      ...prev,
      mrp: newMrp.toFixed(2),
      price: newPrice.toFixed(2),
    }));
  }, [formData]);

  // Booking Data Object
  const bookingData = {
    travelers: updatedData.travelers,
    mrp: parseFloat(updatedData.mrp),
    price: parseFloat(updatedData.price),
    tax: parseFloat(updatedData.tax),
    admin_markup: parseFloat(updatedData.admin_markup),
    booking_id: formData.booking_id || "1234",
    ResultToken: updatedData.ResultToken, // ✅ Now it correctly holds data
    RoomUniqueId: updatedData.RoomUniqueId, // ✅ Now it correctly holds data
    agentid: updatedData.agentid, // ✅ Now it correctly holds data
  };
  


  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;

    script.onload = () => {
      setRazorpayLoaded(true);
      console.log("Razorpay script loaded successfully.");
    };

    script.onerror = () => {
      console.error("Failed to load Razorpay script.");
    };

    document.body.appendChild(script);

    // Clean up script on component unmount
    return () => {
      document.body.removeChild(script);
    };
  }, []);


  // Handle Payment - Send Data to Backend
  const handlePayNow = async () => {
    if (!razorpayLoaded) {
        console.error("Razorpay script is not loaded yet.");
        return;
    }

    try {
        console.log("📤 Booking Data Sent to Backend:", bookingData);

        // Step 1: Initiate Payment with Backend
        const response = await axios.post(`${baseurl}HotelPayout`, bookingData, {
            headers: { "Content-Type": "application/json" },
        });

        console.log("📥 Backend Response:", response.data);

        if (response.status !== 200) {
            alert("Failed to process payment.");
            return;
        }

        const { orderId } = response.data; // Get Razorpay order ID from backend

        // Step 2: Configure Razorpay Payment Options
        const options = {
            key: "rzp_test_doqilf4l91yMln", // Replace with your Razorpay Key ID
            amount: bookingData.price * 100, // Amount in paisa (1 INR = 100 paisa)
            currency: "INR",
            name: "Hotel Booking",
            description: `Booking ID: ${bookingData.booking_id}`,
            order_id: orderId, // Razorpay Order ID from backend
            handler: async (paymentResponse) => {
                console.log("✅ Razorpay Payment Successful:", paymentResponse);

                // Step 3: Confirm Payment to Backend
                try {
                    const confirmResponse = await axios.post(`${baseurl}confirmPayment`, {
                        booking_id: bookingData.booking_id, // Send booking ID to link payment
                        orderId: paymentResponse.razorpay_order_id, // Order ID from Razorpay
                        paymentId: paymentResponse.razorpay_payment_id, // Payment ID from Razorpay
                        signature: paymentResponse.razorpay_signature, // Signature from Razorpay
                    });

                    console.log("✅ Payment Confirmation Response:", confirmResponse.data);
                    // alert("Payment Successful!");

                    // ✅ Navigate to /confirm-hotel-booking with orderId
            navigate(`/confirm-hotel-booking/${paymentResponse.razorpay_order_id}`);

                    // Redirect after successful payment
                    // navigate(`/pay_hotel/${bookingData.booking_id}`);
                } catch (error) {
                    console.error("❌ Error confirming payment:", error);
                    alert("Payment was successful, but we couldn't confirm it. Contact support.");
                }
            },
            prefill: {
                name: bookingData.travelers[0]?.firstName || "Guest",
                email: bookingData.travelers[0]?.email || "guest@example.com",
                contact: bookingData.travelers[0]?.phoneNo || "9999999999",
            },
            theme: { color: "#3399cc" },
        };

        // Step 4: Open Razorpay Payment UI
        const rzp = new window.Razorpay(options);
        rzp.open();
    } catch (error) {
        console.error("❌ Payment Error:", error);
        alert("Error while processing payment.");
    }
};




  return (
    <>
      <Navbar />
      <div className="m-0 p-0">
        <section>
          <div className="tourz-search">
            <div className="container">
              <div className="row">
                <div className="col-md-8 offset-md-2">
                  <div className="invoice-box p-4 border rounded bg-white shadow-sm">
                    <h2 className="text-center mb-4">Hotel Booking Details</h2>

                    {/* Travelers Information */}
                    <h4 className="mb-3">Traveler Details</h4>
                    <table className="table table-bordered">
                      <thead className="thead-dark">
                        <tr>
                          <th>Title</th>
                          <th>Name</th>
                          <th>Age</th>
                          <th>Email</th>
                          <th>Phone No</th>
                          <th>Type</th>
                        </tr>
                      </thead>
                      <tbody>
                        {updatedData.travelers.length > 0 ? (
                          updatedData.travelers.map((traveler, index) => (
                            <tr key={index}>
                              <td>{traveler.title}</td>
                              <td>
                                {traveler.firstName} {traveler.middleName} {traveler.lastName}
                              </td>
                              <td>{traveler.age}</td>
                              <td>{traveler.email}</td>
                              <td>{traveler.phoneNo}</td>
                              <td>{traveler.type}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="6" className="text-center">
                              No traveler information available.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>

                    {/* Booking Information */}
                    <h4 className="mt-4">Booking Details</h4>
                    <table className="table table-bordered">
                      <tbody className="text-start">
                        <tr>
                          <th>Total Price:</th>
                          <td>₹{updatedData.mrp}</td>
                        </tr>
                        
                        <tr>
                          <th>Tax:</th>
                          <td>₹{updatedData.tax}</td>
                        </tr>
                        <tr>
                          <th>Discounted Price:</th>
                          <td>₹{updatedData.price}</td>
                        </tr>
                        {/* <tr>
                          <th>Admin Markup:</th>
                          <td>₹{updatedData.admin_markup}</td>
                        </tr> */}
                      </tbody>
                    </table>

                    {/* Pay Now Button */}
                    <div className="text-center mt-4">
                      <button className="btn btn-primary btn-lg" onClick={handlePayNow}>
                        Pay Now ₹{updatedData.price}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default VisitorHotelBookingFinalPage;
